import { TickOutlined } from '@aircall/icons';
import {
  Avatar,
  AvatarText,
  Badge,
  Button,
  Flex,
  ModalBody,
  ModalDialog,
  ModalFooter,
  Spacer,
  Tag,
  Typography,
} from '@aircall/tractor-v2';
import { RolesTags } from '@components/RolesTags';
import { GetAllRolesQuery_getAllRoles } from '@generated/GetAllRolesQuery';
import { useTranslation } from 'react-i18next';

interface AgentsCreationSuccessModalProps {
  isModalOpen: boolean;
  onClose: () => void;
  firstName?: string;
  roles?: GetAllRolesQuery_getAllRoles[];
  lastName?: string;
}

export function AgentsCreationSuccessModal({
  isModalOpen,
  onClose,
  firstName,
  roles,
  lastName,
}: AgentsCreationSuccessModalProps) {
  const { t } = useTranslation();

  return (
    <ModalDialog show={isModalOpen} onHide={onClose} size='small'>
      <ModalBody py='xl'>
        <Spacer
          data-test='agents-creation-success-modal'
          direction='vertical'
          space='s'
          alignItems='center'
          px='l'
          fluid
        >
          <Flex
            borderWidth={1}
            borderStyle='solid'
            borderColor='neutral-200'
            borderRadius='sm'
            px='l'
            pt='s'
            pb='m'
            backgroundColor='neutral-0'
            minWidth={160}
            maxWidth={320}
            alignItems='center'
            flexDirection='column'
          >
            <Badge size='large' icon={<TickOutlined />}>
              <Avatar size='large' variant='default' data-test='created-initials'>
                <AvatarText name={`${firstName} ${lastName}`} />
              </Avatar>
            </Badge>
            <Typography
              variant='bodySemiboldM'
              fontWeight={600}
              data-test='created-fullname'
              ellipsis
              py='xxs'
            >
              {firstName} {lastName}
            </Typography>
            {roles ? (
              <RolesTags roles={roles} />
            ) : (
              <Tag variant='blue'>{t('users.creation.success_modal.tag')}</Tag>
            )}
          </Flex>
          <Typography variant='bodySemiboldM' fontWeight={600}>
            {firstName} {lastName} {t('users.creation.success_modal.info')}
          </Typography>
        </Spacer>
      </ModalBody>
      <ModalFooter>
        <Button onClick={onClose} data-test='create-user-success-modal-button'>
          {t('users.creation.success_modal.button')}
        </Button>
      </ModalFooter>
    </ModalDialog>
  );
}
